import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { isAuthenticated } from "../utils/fetchWithAuth";
import { pendingPostMessage } from "@/lib/postDrafts";
import PhIcon from "./PhIcon";

/* A message somebody wrote on a post before they had an account, still unsent.

   The post page keeps the draft while they sign up (pages/postings/
   PublicPostingDetailPage). A person's signup returns them to the post, but a
   company's signup runs through company setup, and anyone can wander off
   before sending. So wherever they are once signed in, this offers the way
   back. It never sends anything itself. */
export default function PendingMessageBanner() {
  const { pathname } = useLocation();
  const [pending, setPending] = useState(null);

  useEffect(() => {
    // Not on the post itself, and not on the sign-in and sign-up screens.
    if (!isAuthenticated() || pathname.startsWith("/postings/") || pathname.startsWith("/auth")) { setPending(null); return; }
    setPending(pendingPostMessage());
  }, [pathname]);

  if (!pending) return null;
  const dismiss = () => {
    try { sessionStorage.setItem(`sift_post_draft_dismissed_${pending.id}`, "1"); } catch { /* fine */ }
    setPending(null);
  };
  return (
    <div
      role="status"
      style={{
        position: "fixed", left: 16, right: 16, bottom: 16, zIndex: 70, maxWidth: 560, margin: "0 auto",
        display: "flex", alignItems: "center", gap: 12, padding: "12px 12px 12px 16px", borderRadius: 12,
        background: "#0F4A39", color: "#F6F1E4", boxShadow: "0 12px 32px rgba(0,0,0,.2)",
        fontFamily: "var(--font-sans)", fontSize: 14, lineHeight: "20px",
      }}
    >
      <span style={{ flex: 1, minWidth: 0 }}>
        Your message{pending.to ? ` to ${pending.to}` : ""} is ready to send.
      </span>
      <Link
        to={`/postings/${pending.id}`}
        style={{ background: "#F6F1E4", color: "#0F4A39", borderRadius: 8, padding: "8px 14px", fontWeight: 600, whiteSpace: "nowrap" }}
      >
        Send it
      </Link>
      <button type="button" onClick={dismiss} aria-label="Dismiss" style={{ border: 0, background: "transparent", color: "#C9DBD1", display: "grid", placeItems: "center", width: 32, height: 32, cursor: "pointer" }}>
        <PhIcon name="x" size={18} />
      </button>
    </div>
  );
}
